import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { fromEvent, merge, Observable } from 'rxjs';
import { distinctUntilChanged, map, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ResizeService {
  private readonly resize$: Observable<{ innerWidth: number; innerHeight: number }>;

  constructor(@Inject(PLATFORM_ID) private readonly platformId: Object) {
    const resize = fromEvent(window, 'resize').pipe(
      // debounceTime(150),
      map(() => {
        return { innerWidth: window.innerWidth, innerHeight: window.innerHeight };
      })
    );

    const orientationChange = fromEvent(window, 'orientationchange').pipe(
      switchMap(() => this.orientationChanged()),
      map(() => {
        return { innerWidth: window.innerWidth, innerHeight: window.innerHeight };
      })
    );

    this.resize$ = merge(resize, orientationChange).pipe(
      distinctUntilChanged((prev, curr) => {
        return prev.innerWidth === curr.innerWidth && prev.innerHeight === curr.innerHeight;
      })
    );
  }

  resize(): Observable<{ innerWidth: number; innerHeight: number }> {
    return this.resize$;
  }

  orientationChanged(): Observable<boolean> {
    const timeout = 1;
    return new Observable((observer) => {
      const go = (i, height0) => {
        if (window.innerHeight !== height0 || i >= timeout) {
          setTimeout(() => {
            observer.next(true);
            return observer.complete();
          });
        } else if (isPlatformBrowser(this.platformId)) {
          return window?.requestAnimationFrame(() => go(i++, height0));
        }
      };

      go(0, window.innerHeight);
    });
  }
}
